import { motion } from 'framer-motion';
import { V2DumbBackground } from './V2DumbBackground';

/**
 * Single unified loading screen for the entire V2 experience.
 * Used by: RequireAuth, AppFlowOverlay, V2Layout sub-loading gate.
 */
export function V2LoadingScreen() {
  return (
    <div className="dark fixed inset-0 z-50 flex items-center justify-center">
      <V2DumbBackground />
      <motion.div
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="flex flex-col items-center gap-5"
      >
        {/* Logo with subtle pulse */}
        <div className="relative w-20 h-20 flex items-center justify-center">
          {/* Spinning ring */}
          <div
            className="absolute inset-0 rounded-full animate-spin"
            style={{
              background: 'conic-gradient(from 0deg, rgba(255,255,255,0.5), rgba(255,255,255,0.08), transparent)',
              mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              maskComposite: 'exclude',
              WebkitMaskComposite: 'xor',
              padding: '2.5px',
              animationDuration: '1.4s',
            }}
          />
          <img
            src="/logo.png"
            alt="BuxBox"
            className="w-12 h-12 object-contain rounded-xl"
          />
        </div>
      </motion.div>
    </div>
  );
}
